import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { HttpService, Query, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export type EInvoiceReceivedGetKsefHashResponse = EInvoiceReceivedGetKsefHashDTO;

class EInvoiceReceivedGetKsefHashDTO {
    ksefHash: string;
}

export class EInvoiceReceivedGetKsefHashQuery extends Query<EInvoiceReceivedGetKsefHashResponse> {
    public constructor(public readonly params: {id: number}) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(EInvoiceReceivedGetKsefHashQuery)
export class EInvoiceReceivedGetKsefHashQueryHandler {
    #Url = TaggedUrl.join('eInvoices/headers/:id/hash', [Tags.Api]);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: EInvoiceReceivedGetKsefHashQuery): Promise<EInvoiceReceivedGetKsefHashResponse> {
        const url = fillPlaceholders(this.#Url, {id: query.params.id})
        const { data } = await this.#http.get<EInvoiceReceivedGetKsefHashDTO>(url);
        return data;
    }
}
